/*
 * @Author: your name
 * @Date: 2021-06-07 10:32:07
 * @LastEditTime: 2025-07-17 09:09:16
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\store\index.js
 */
import Vue from 'vue';
import 'es6-promise/auto';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import mutations from './mutations';
import actions from './action';
import getters from './getters';
// import { setStore, getStore } from '../utils/storage'
Vue.use(Vuex);

const state = {
  collapse: false,
  logoImgList: '',
  productInfo: [
    { label: '操作', param: 'id', align: 'center', slot: 'id' },
    { label: '图片', param: 'img', align: 'center', slot: 'img' },
    { label: '商品名称', param: 'skuName', align: 'center', slot: 'skuName' },
    { label: '库存', param: 'skuStock', align: 'center', slot: 'skuStock' },
    {
      label: '起订量',
      param: 'minOrderQuantity',
      align: 'center',
      slot: 'minOrderQuantity',
    },
    {
      label: '订单是否确认',
      param: 'isConfirm',
      align: 'center',
      slot: 'isConfirm',
    },
    {
      label: '发货周期(天)',
      param: 'deliverTime',
      align: 'center',
      slot: 'deliverTime',
    },
    {
      label: '计量单位',
      param: 'unitValue',
      align: 'center',
      slot: 'unitValue',
    },
    { label: '市场公开价(元)', param: 'price', align: 'center', slot: 'price' },
  ],
  // 是否登录
  pCategory: '',
  // 发布商品列表
  productList: {
    categoryName: '',
    categoryId: '',
    attributeStr: '', // 属性字符串
    attributes: {}, // 属性数组
    brandId: '',
    brandName: '',
    taxRateId: '',
    taxRateValue: '',
    salesScope: '',
    salesScopeId: '',
    remark: null,
    skuFiles: [],
  },
  categoryList: {}, // 选择后属性列表
  productTableList: [], // 商品数据表
  createProductTableList: [], // 创建的商品信息
  buttonDirective: [], // 按钮权限
  moduleBelong: '', // 首页铃铛消息选项卡
  tagsList: [],
  /// ///数据存储//////////
  USERINFO: {}, // 用户信息
  MENUINFO: {}, // 菜单列表
  BRANDINfO: {}, // 店铺信息
  MENULIST: [], // 用户菜单集合
  sider_bar: true, // 左边侧边栏菜单
  supplierScoreInfo: {}, // 供应商评分信息

  isShowRightBar: false,
  showLib: 0,
  routerParams: {
    orderDetailOrConfirm: null, // 订单详情确认页
  }, // 路由传参加密
  yearList: [], // 企业信用评级年份
  isProtocol: '', // 采购产品范围
};
export default new Vuex.Store({
  plugins: [createPersistedState()],
  state,
  getters,
  actions,
  mutations,
});
